var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathenormally(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.33203H9.33333C9.7289 5.33203 10.1156 5.21473 10.4445 4.99497C10.7734 4.77521 11.0297 4.46285 11.1811 4.0974C11.3325 3.73195 11.3721 3.32981 11.2949 2.94185C11.2177 2.55389 11.0273 2.19752 10.7475 1.91782C10.4678 1.63811 10.1115 1.44763 9.72351 1.37046C9.33555 1.29329 8.93342 1.3329 8.56797 1.48427C8.20251 1.63565 7.89016 1.89199 7.67039 2.22089C7.45063 2.54979 7.33333 2.93647 7.33333 3.33203M2 7.9987H12C12.3956 7.9987 12.7822 8.116 13.1111 8.33576C13.44 8.55552 13.6964 8.86788 13.8478 9.23333C13.9991 9.59878 14.0387 10.0009 13.9616 10.3889C13.8844 10.7768 13.6939 11.1332 13.4142 11.4129C13.1345 11.6926 12.7781 11.8831 12.3902 11.9603C12.0022 12.0374 11.6001 11.9978 11.2346 11.8465C10.8692 11.6951 10.5568 11.4387 10.3371 11.1098C10.1173 10.7809 10 10.3943 10 9.9987M2 10.6654H6.66667",
    strokeWidth: 1.26667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathenormally);
export default __webpack_public_path__ + "static/media/breathe normally.8d80d56df19991ff1b59972378f40f41.svg";
export { ForwardRef as ReactComponent };